import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { set_pay_type_action } from '../../actions/setPayTypeAction';
import { set_gold_gram_usage } from '../../actions/cartActions';
import NumberFormat from 'react-number-format';
import './PaymentTypeSection.css';
import { Button } from 'react-bootstrap';
import { CreditCard, Wallet, Coins, Receipt } from 'lucide-react';
import { ENABLE_GOLD_WALLET_IN_CART } from '../../themeSetting';

const PaymentTypeSection = ({ nextStep }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const payType = useSelector((state) => state.pay_type);
  const depositPrice = useSelector((state) => state.deposit_price);
  const walletGearmValue = useSelector((state) => state.cart.wallet_gearm_value) || 0;
  const goldPrice = useSelector((state) => state.gold_price) || 0;
  const goldGramCartUsage = useSelector((state) => state.cart.gold_gram_cart_usage) || 0;
  const [gramInput, setGramInput] = useState(goldGramCartUsage > 0 ? String(goldGramCartUsage) : '');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (payType === 'receipt' || payType === 'sheba') {
      dispatch(set_pay_type_action('cashe'));
    }
  }, [payType, dispatch]);
  // Don't render if user doesn't have deposit option
  if (user['is_deposit'] !== 1) {
    return null;
  }

  const handlePaymentTypeChange = (value) => {
    dispatch(set_pay_type_action(value));
  };

  const handleClick = (data) => {
    nextStep();
  };

  const isDepositDisabled = depositPrice === 0;

  return (
    <>
      <div className='payment-type-section rtl'>
        <div className='payment-type-section__title'>انتخاب نحوه پرداخت</div>

        <div className='payment-type-section__options'>
          {/* پرداخت نقدی */}
          <div className={`payment-type-section__option ${payType === 'cashe' ? 'payment-type-section__option--selected' : ''}`}>
            <input
              onChange={(e) => handlePaymentTypeChange(e.target.value)}
              className='payment-type-section__input'
              type='radio'
              name='payType'
              checked={payType === 'cashe'}
              value='cashe'
              id='cashe'
            />
            <label className='payment-type-section__label' htmlFor='cashe'>
              <div className='payment-type-section__icon'>
                <Wallet size={22} />
              </div>
              <span className='payment-type-section__text'>پرداخت آنلاین</span>

              {/* Checkmark - سمت چپ */}
              <div className='payment-type-section__checkmark'>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                  <path d='M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z' fill='currentColor' />
                </svg>
              </div>
            </label>
          </div>

          {/* پرداخت بیعانه */}
          <div
            className={`payment-type-section__option ${payType === 'deposit' ? 'payment-type-section__option--selected' : ''} ${
              isDepositDisabled ? 'payment-type-section__option--disabled' : ''
            }`}
          >
            <input
              onChange={(e) => handlePaymentTypeChange(e.target.value)}
              disabled={isDepositDisabled}
              className='payment-type-section__input'
              checked={payType === 'deposit'}
              type='radio'
              name='payType'
              value='deposit'
              id='deposit'
            />
            <label className={`payment-type-section__label ${isDepositDisabled ? 'payment-type-section__label--disabled' : ''}`} htmlFor='deposit'>
              <div className='payment-type-section__icon'>
                <Wallet size={22} />
              </div>
              <span className='payment-type-section__text'>
                <div className='payment-type-section__text-main'>پرداخت بیعانه</div>
                <div className='payment-type-section__text-sub'>
                  (<NumberFormat value={depositPrice} displayType='text' thousandSeparator={true} className='payment-type-section__price' /> تومان)
                </div>
              </span>

              {/* Checkmark - سمت چپ */}
              <div className='payment-type-section__checkmark'>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                  <path d='M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z' fill='currentColor' />
                </svg>
              </div>
            </label>
          </div>

          {/* فیش واریزی - به زودی */}
          <div className='payment-type-section__option payment-type-section__option--disabled'>
            <div className='payment-type-section__label payment-type-section__label--disabled'>
              <div className='payment-type-section__icon'>
                <Receipt size={22} />
              </div>
              <span className='payment-type-section__text'>
                <div className='payment-type-section__text-main'>فیش واریزی</div>
              </span>
              <div className='payment-type-section__soon-badge'>به زودی</div>
            </div>
          </div>

          {/* استفاده از موجودی گرمی */}
          {ENABLE_GOLD_WALLET_IN_CART && walletGearmValue > 0 && (
            <div
              className={`payment-type-section__option ${goldGramCartUsage > 0 ? 'payment-type-section__option--selected' : ''}`}
              onClick={() => {
                if (goldGramCartUsage > 0) {
                  dispatch(set_gold_gram_usage(0));
                } else {
                  dispatch(set_gold_gram_usage(walletGearmValue));
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              <input
                className='payment-type-section__input'
                type='checkbox'
                checked={goldGramCartUsage > 0}
                readOnly
              />
              <label className='payment-type-section__label'>
                <div className='payment-type-section__icon'>
                  <Coins size={22} />
                </div>
                <span className='payment-type-section__text'>
                  <div className='payment-type-section__text-main'>استفاده از موجودی گرمی</div>
                  <div className='payment-type-section__text-sub'>
                    ({parseFloat(walletGearmValue).toFixed(2)} گرم)
                  </div>
                </span>

                <div className='payment-type-section__checkmark'>
                  <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                    <path d='M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z' fill='currentColor' />
                  </svg>
                </div>
              </label>
            </div>
          )}

        </div>
      </div>
      <div
        className='d-grid gap-2 mt-4'
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          gap: '10px',
        }}
        onClick={handleClick}
      >
        <Button type='button' className='confirm-button'>
          <span className='confirm-text'>مرحله بعد</span>
        </Button>
      </div>
    </>
  );
};

export default PaymentTypeSection;
